import Vue from 'vue'

import router from './router'
import store from './store'
import Router from './component/Router.vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { closeSpashscreen } from '../util'

import './_asset/scss/app.scss'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

export const render = (user) => {
  new Vue({
    router,
    store,
    render: h => h(Router),
    beforeCreate () {
      this.$store.commit('user', user)
    },
    mounted () {
      closeSpashscreen(this)
    }
  }).$mount('#app')
}
